// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Wu","sizeMedium":"e_Xu","sizeSmall":"e_Yu","icon":"e_Zu"};